import { selectOpportunityListId } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import {
    COMMON_WORKSPACES_SET_FEED_DATA,
    COMMON_WORKSPACES_SET_FEED_ITEMS_SEEN,
} from "app/pages/workspace/common/action_types/actionTypes";
import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

import * as ac from "./action-creators";

export const fetchFeedsThunk =
    (domain: string, workspaceId?: string, opportunityListId?: string) =>
    async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        dispatch(ac.fetchFeedsAsyncAction.request());

        const salesIntelligenceListId = selectOpportunityListId(getState());
        const id = opportunityListId || salesIntelligenceListId;

        try {
            const feeds = await deps.si.api.feed.fetchWebsiteFeed({ domain });
            dispatch(ac.fetchFeedsAsyncAction.success(feeds));

            // FIXME: Copied from "common_workspace_action_creators.ts" for compatibility.
            dispatch({
                type: COMMON_WORKSPACES_SET_FEED_DATA,
                data: feeds,
            });

            if (feeds && id) {
                const seenItems = feeds.filter((item) => !item?.lastSeenDate).map((item) => item?.id);

                if (seenItems.length > 0) {
                    await deps.si.api.feed.setFeedItemsSeen({
                        domain,
                        workspaceId,
                        opportunityListId: id,
                        feedItemsIds: seenItems,
                    });

                    dispatch({
                        type: COMMON_WORKSPACES_SET_FEED_ITEMS_SEEN,
                        domain,
                        seenItems,
                    });
                }
            }
        } catch (e) {
            dispatch(ac.fetchFeedsAsyncAction.failure(e));
        }
    };

export const fetchTopCountriesThunk =
    (domain: string) => async (dispatch: ThunkDispatchCommon, _: ThunkGetState, deps: ThunkDependencies) => {
        dispatch(ac.fetchTopCountriesAsyncAction.request());
        try {
            const topCountries = await deps.si.api.feed.fetchTopCountries(domain);
            dispatch(ac.fetchTopCountriesAsyncAction.success(topCountries));
        } catch (error) {
            dispatch(ac.fetchTopCountriesAsyncAction.failure(error));
        }
    };
export const fetchAdNetworksThunkAction =
    (domain: string, country: string | number) =>
    async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        dispatch(ac.fetchAdNetworksAsyncAction.request());
        try {
            const networks = await deps.si.api.feed.fetchAdNetworks(domain, country);
            dispatch(ac.fetchAdNetworksAsyncAction.success(networks));
        } catch (error) {
            dispatch(ac.fetchAdNetworksAsyncAction.failure(error));
        }
    };
export const fetchSiteInfoThunkAction =
    (domain: string, country: number) =>
    async (dispatch: ThunkDispatchCommon, _: ThunkGetState, deps: ThunkDependencies) => {
        dispatch(ac.fetchSiteInfoAsyncAction.request());
        try {
            const siteInfo = await deps.si.api.feed.fetchSiteInfo(domain, country);
            dispatch(ac.fetchSiteInfoAsyncAction.success(siteInfo));
        } catch (error) {
            dispatch(ac.fetchSiteInfoAsyncAction.failure(error));
        }
    };
